module.exports = __webpack_public_path__ + "fontawesome-webfont.b06871f281fee6b241d6.ttf";


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/assets/fonts/fontawesome-webfont.ttf?v=4.7.0
// module id = ../../../../../src/assets/fonts/fontawesome-webfont.ttf?v=4.7.0
// module chunks = styles